import {
  getShouldShowBannerNotificationsUX,
  getShouldShowReaderBlur,
  handleBannerNotification,
  logViewRestrictionEvent,
  ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION,
  CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS,
  isRevisit,
  trackView,
  getContentGateDataFromStorage,
} from "./content-gate-common"
import { player } from "app/assets/javascripts/new_player/selectors"
import { isLocalStorageEnabled } from "app/assets/javascripts/utils/localstorage"
import { logSlideshowViewed } from "app/assets/javascripts/tracking/amplitude/log-slideshow-events"
import { getFlagValue } from "app/assets/javascripts/utils/ab_tests"

window.addEventListener("DOMContentLoaded", async () => {
  const slideshare_object = window.slideshare_object
  const slideshow = slideshare_object && slideshare_object.slideshow
  const enableViewRestriction = await getEnableViewRestriction(slideshow)

  if (enableViewRestriction) {
    const numberOfViewedDocuments = trackView(slideshow.id)
    logViewRestrictionEvent(numberOfViewedDocuments)
    logSlideshowViewed({
      viewRestrictionState: getViewRestrictionState(numberOfViewedDocuments),
      viewRestrictionCounter: numberOfViewedDocuments,
    })
    applyViewRestrictionUx(numberOfViewedDocuments)
  }
})

const getEnableViewRestriction = async (slideshow) => {
  const isFeatureFlagActive = await getFlagValue("view_restriction_without_subscription_after_five")
  // Showing ads replaces view restriction when it's on
  const isShowingAds = await getFlagValue("frame_ads")

  if (!isFeatureFlagActive || !slideshow || isShowingAds) {
    // Disabled by feature flag or no slideshow on this page, bail early
    logSlideshowViewed({ viewRestrictionState: null, viewRestrictionCounter: null })
    return false
  }

  if (!isLocalStorageEnabled()) {
    // with local storage disabled, we cannot keep track of viewed content
    logSlideshowViewed({ viewRestrictionState: "not supported", viewRestrictionCounter: null })
    return false
  }

  if (!slideshow.view_restriction_eligible) {
    // Slideshow is not eligible for view restriction.
    logSlideshowViewed({ viewRestrictionState: "unrestricted", viewRestrictionCounter: null })
    return false
  }

  if (isRevisit(slideshow.id)) {
    const count = getContentGateDataFromStorage().length
    // User is revisiting Slideshow
    logSlideshowViewed({ viewRestrictionState: "revisit", viewRestrictionCounter: count })
    return false
  }

  return true
}

function applyViewRestrictionUx(contentAccountGateDataLen) {
  const slideshare_object = window.slideshare_object
  const { shouldShowBanner, remainingDocCount } = getShouldShowBannerNotificationsUX(
    ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION,
    contentAccountGateDataLen,
    CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS
  )
  const shouldBlurReader = getShouldShowReaderBlur(
    ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION,
    contentAccountGateDataLen
  )

  // Handle UX
  if (shouldShowBanner) {
    handleBannerNotification(remainingDocCount, slideshare_object)
  }

  if (shouldBlurReader) {
    player.attr("data-shouldblurreader", shouldBlurReader)
  }
}

function getViewRestrictionState(currentCount) {
  const contentLimitForBanner =
    ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION - CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS
  if (currentCount < contentLimitForBanner) {
    return "unrestricted"
  } else if (currentCount >= contentLimitForBanner && currentCount <= ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION) {
    return "warning"
  } else {
    return "restricted"
  }
}
